import { render, staticRenderFns } from "./hotel-configuration.vue?vue&type=template&id=1464483a&"
import script from "./hotel-configuration.vue?vue&type=script&lang=ts&"
export * from "./hotel-configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports